import { Empty } from 'antd';
import { mimeToExtension } from 'constants/knowledge-base';
export const throttle = (fn, ms) => {
	let timerId;
	return function () {
		if (!timerId) {
			timerId = setTimeout(() => {
				timerId = null;
				fn.apply(this, arguments);
			}, ms);
		}
	};
};
export const emptyTemplate = () => {
	return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<span>notData</span>} />;
};

export function displayText(value) {
	if (value || value === 0 || value === '0') {
		return value;
	} else {
		return <div className="cursor-default-com">-</div>;
	}
}

export function displayTextForFileExt(ext) {
	if (!ext) {
		return '-';
	}
	if (mimeToExtension[ext]) {
		return mimeToExtension[ext];
	}
	if (ext.includes('/')) {
		return ext.split('/')[1];
	}
	return ext.toUpperCase();
}

export function displayTextForFileSize(size) {
	if (!size) {
		return '-';
	}
	let sizeInBytes = parseFloat(size);

	if (isNaN(sizeInBytes) && typeof size === 'string') {
		if (size.includes('KB') || size.includes('MB') || size.includes('GB')) {
			return size;
		}
		return '';
	}
	if (sizeInBytes >= 1024 * 1024) {
		// MB
		return (sizeInBytes / (1024 * 1024)).toFixed(2) + ' MB';
	} else if (sizeInBytes >= 1024) {
		// KB
		return (sizeInBytes / 1024).toFixed(2) + ' KB';
	} else {
		// Bytes
		return sizeInBytes + ' B';
	}
}

export function displayTextForArray(array) {
	if (!array) return '-';
	if (Array.isArray(array)) {
		return array.join(', ');
	}
	return array;
}
